import React, { useState, useEffect } from "react";
import TTB from "ttb-client";
import { CoverageForm, Text } from "ttb-reactjs-components";

const CoverageComponent = (props) => {
  const src = window.location.href;
  const url = src ? new URL(src) : null;
  const [token] = useState(url?.searchParams.get("token") ?? null);

  useEffect(() => {
    if (token) {
      TTB.init("prod", token);
    }
  }, [token]);

  const returnJSON = (json) => {
    console.log(json);
    window.parent.postMessage(json, "*");
  };

  return token ? (
    <CoverageForm Location={TTB.WD.Location} onChange={returnJSON} />
  ) : (
    <Text>Para inicializar el componente añade un token de conexión</Text>
  );
};
export default CoverageComponent;
